import React from 'react';

import CourseTeaser from './Teaser';

const Course = ({ entity, viewMode, ...props }) => {
  return (<CourseTeaser entity={entity} {...props} />);
};

export default Course;
